import { ReactNode } from 'react'
import { Portal } from '@/components/portal/Portal'

export interface ConditionalPortalWrapperProps {
  children: ReactNode
  isPortal: boolean
}

export const ConditionalPortalWrapper = ({
  children,
  isPortal
}: ConditionalPortalWrapperProps) => {
  if (isPortal) {
    return <Portal>{children}</Portal>
  }

  return <>{children}</>
}
